import {
  GET_TRANSFER,
  GET_TRANSFER_SUCCESS,
  GET_TRANSFER_FAIL,
  DELETE_TRANSFER,
  DELETE_TRANSFER_SUCCESS,
  DELETE_TRANSFER_FAIL,
  UPDATE_TRANSFER,
  UPDATE_TRANSFER_SUCCESS,
  UPDATE_TRANSFER_FAIL,
  ADD_NEW_TRANSFER,
  ADD_TRANSFER_SUCCESS,
  ADD_TRANSFER_FAIL,
  TRANSFER_LOADING,
  TRANSFER_RESET,
} from "./actionType";

export const resetTransferState = (actionType) => ({
  type: TRANSFER_RESET,
  payload: { actionType },
});

export const getTransferSuccess = (actionType, data) => ({
  type: GET_TRANSFER_SUCCESS,
  payload: { actionType, data },
});

export const getTransferFail = (actionType, error) => ({
  type: GET_TRANSFER_FAIL,
  payload: { actionType, error },
});

export const getTransfer = data => ({
  type: GET_TRANSFER,
  payload: data,
});

export const getTransferLoading = () => ({
  type: TRANSFER_LOADING
});

export const deleteTransfer = data => ({
  type: DELETE_TRANSFER,
  payload: data,
});

export const deleteTransferSuccess = data => ({
  type: DELETE_TRANSFER_SUCCESS,
  payload: data,
});

export const deleteTransferFail = error => ({
  type: DELETE_TRANSFER_FAIL,
  payload: error,
});

export const updateTransfer = data => ({
  type: UPDATE_TRANSFER,
  payload: data,
});

export const updateTransferFail = error => ({
  type: UPDATE_TRANSFER_FAIL,
  payload: error,
});

export const updateTransferSuccess = data => ({
  type: UPDATE_TRANSFER_SUCCESS,
  payload: data,
});

export const addNewTransfer = data => ({
  type: ADD_NEW_TRANSFER,
  payload: data,
});

export const addTransferSuccess = data => ({
  type: ADD_TRANSFER_SUCCESS,
  payload: data,
});

export const addTransferFail = error => ({
  type: ADD_TRANSFER_FAIL,
  payload: error,
});